import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "book-day__img-box" }
const _hoisted_4 = {
  key: 0,
  class: "book-day__play"
}
const _hoisted_5 = { class: "book-day__text-box" }
const _hoisted_6 = { class: "book-day__category" }
const _hoisted_7 = { class: "book-day__title" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "book-day__author" }

import { onBeforeMount, ref } from 'vue'
import { useRouter } from 'vue-router'

import { Mixpanel } from '@/analytics/mixpanel'
import type { BookOfTheDayView } from '@/models/doc.book'
import type { BookListItem } from '@/models/interfaces'
import { platform } from '@/services/platform'
import { Sentry } from '@/services/sentry'
import { playerSession } from '@/services/player'
import { isSafari as _isSafari } from '@/helpers/userAgent'

import BookCover from '@/app/components/book/card/BookCover.vue'
import BookCardBackground from '@/app/components/book/card/BookCardBackground.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BookOfTheDayBlock',
  props: {
    title: {},
    view: {}
  },
  setup(__props: any) {

const props = __props

const isSafari = ref(false)

onBeforeMount(async () => {
  isSafari.value = (await platform.isIOS()) || _isSafari()
})

const router = useRouter()

function trackDocView(event: Event, doc: BookListItem): void {
  try {
    playerSession.value.setNextArrival('card')
    Mixpanel.trackDocView(
      event,
      props.title,
      router.currentRoute.value.fullPath,
      doc,
    )
  } catch (error: any) {
    // Unexpected error in the Mixpanel tracking
    Sentry.captureException(error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (__props.view.book)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.title), 1),
        _createVNode(_component_router_link, {
          to: __props.view.link,
          class: _normalizeClass(["book-day", { 'book-day--safari': isSafari.value }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (trackDocView($event, __props.view.book)))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (__props.view.book.has_audio)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("span", { class: "book-day__play-icon iconfont iaudio" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true),
              _createVNode(BookCover, {
                doc: __props.view.book,
                coverClass: "book-day__img",
                fallbackCoverClass: "book-day__img-fallback"
              }, null, 8, ["doc"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(__props.view.category), 1),
              _createElementVNode("h3", _hoisted_7, _toDisplayString(__props.view.book.title), 1),
              _createElementVNode("div", {
                class: "book-day__text",
                innerHTML: __props.view.description
              }, null, 8, _hoisted_8),
              _createElementVNode("h4", _hoisted_9, "By " + _toDisplayString(__props.view.book.author), 1)
            ]),
            (!isSafari.value)
              ? (_openBlock(), _createBlock(BookCardBackground, {
                  key: 0,
                  doc: __props.view.book
                }, null, 8, ["doc"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["to", "class"])
      ]))
    : _createCommentVNode("", true)
}
}

})